import React, { useState, useEffect } from 'react'
import { bikeI } from '../interfaces/bikes'
//, bikesresponseFromApi, countBikesresponseFromApi ,bikesOnlineResponseFromApi
import { getBikes, getCountBikes } from '../services/getBikes'
import { useNavigate } from "react-router";

interface FormState {
  datefrom?: string
  dateto?: string
  query?: string
}

interface FormProp {
  onSearchBike: (bikes: bikeI[]) => void,
  pageParam: string | undefined,
  loadNow: Boolean
}

const FormBikes = ({ onSearchBike, pageParam = "1", loadNow }: FormProp) => {

  const history = useNavigate();
  let [page, setPage] = useState(parseInt(pageParam))
  let [inited, setInited] = useState(false)
  const [inputValues, setInputValues] = useState<FormState>({
    datefrom: '',
    query: '',
    dateto: ''
  })
  let [error, setError] = useState<any>(null)
  let [isLoaded, setIsLoaded] = useState(true)
  let [countBikes, setCountBikes] = useState(0)


  const handleSubmit = (event: React.FormEvent<HTMLFormElement> | null) => {

    if (event)
      event.preventDefault()

    setIsLoaded(false)

    let title = '', fromto = ''

    if (inputValues.query)
      title = `&query=${inputValues.query}`

    if (inputValues.datefrom && inputValues.dateto) {

      fromto = `&date_stolen=${inputValues.datefrom}`

      if (inputValues.dateto)
        fromto += `|${inputValues.dateto}`

    } else if (inputValues.dateto)
      fromto += `&date_stolen=${inputValues.dateto}`
    else if (inputValues.datefrom)
      fromto += `&date_stolen=${inputValues.datefrom}`

    getAllBikesCustom(title, fromto)
  }

  function getAllBikesCustom(title: string, fromto: string) {
    try {

      getCountBikes(title)
        .then(
          (result) => {
            setIsLoaded(true)
            setCountBikes(result.stolen)
          }
        )

      getBikes(page, title, fromto)
        .then(
          (result) => {
            setIsLoaded(true)
            //setBikes(mapFromApiToBickes(result.bikes))
            //setBikes(result.bikes)
            onSearchBike(result.bikes)

          }
        )

      //en el caso que el json de la api sea diferenrte a que se usa
      /* const mapFromApiToBickes = (apiResponse: bikesOnlineResponseFromApi):
      Array<bikeI> => {
        return apiResponse.map(bikeFromApi => {
          const {
            url_online: url,
            thumb_online: thumb,
            title_online: title,
            description_online: description,
            serial_online: serial,
            frame_colors_online: frame_colors,
            el2_online: el2,
            stolen_online: stolen,
            date_stolen_online:date_stolen,
            year_online:year,
            stolen_location_online:stolen_location,
          } = bikeFromApi
  
          return {
            url,
            thumb,
            title,
            description,
            serial,
            frame_colors,
            el2,
            stolen,
            date_stolen,
            year,
            stolen_location
          }
        })
      } */

    } catch (error) {
      setIsLoaded(true)
      setError(error)
    }

  }

  const handeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value
    })
  }

  function nextPage() {
    setPage((page += 1))
    history("/home/" + page);
  }
  function backPage() {
    setPage((page -= 1))
    history("/home/" + page);
  }
  function goPage(pageselect = 1) {
    setPage(pageselect)
    history("/home/" + pageselect);
  }

  //init page
  useEffect(() => {
    console.log("loadNow useEffect loadNow", loadNow)
    console.log("loadNow useEffect inited", inited)
    if (loadNow === true && inited === false) {
      setInited(true)
      console.log("loadNow useEffect setInited ", inited)
      console.log("loadNow useEffect loadNow ", loadNow)
      getAllBikesCustom('', '');
      return
    } else {
      handleSubmit(null)
    }
  }, [page])

  if (error) {
    return <div>Error Oooops, something went wrong: {error.message}</div>
  } else if (!isLoaded) {
    return <div>Loading...</div>
  } else
    return (
      <div className="row">
        <form onSubmit={handleSubmit} className="col-12 needs-validation m-3" >
          <h4 className="mb-3">Stolen Bikes Search</h4>
          <div className="row">
            <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <input
                className="form-control"
                name="query"
                placeholder="Search cases title"
                type="text"
                value={inputValues.query}
                onChange={handeChange}
              />
            </div>

            <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <input
                className="form-control"
                name="datefrom"
                placeholder="From"
                type="date"
                value={inputValues.datefrom}
                onChange={handeChange}
              />
            </div>

            <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <input
                className="form-control"
                name="dateto"
                placeholder="To"
                type="date"
                value={inputValues.dateto}
                onChange={handeChange}
              />
            </div>

            <div className="col-auto" >
              <button className="btn btn-primary" type="submit">{/*  onClick={() => search()} */}
                Find cases
              </button>
            </div>
          </div>

        </form>

        <div className="col-12 m-3">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-2 col-xl-2">
              <p>Page Current: {page}</p>
            </div>

            <div className="col-auto">
              <div className='btn-group' role="group" aria-label="Button group with nested dropdown">


                {page > 1 ? (
                  <button className="btn btn-info" type="button" onClick={() => backPage()}>
                    {"Back Page <"}
                  </button>
                ) : null}

                {(new Array(11).fill(Math.random())).map((el, idx) => (
                  <button key={idx} disabled={page === idx + 1 ? true : false} className={"btn btn-primary " + ((idx+1 > 6) ? ' d-none d-md-block ': ' ') } type="button" onClick={() => goPage(idx + 1)}>
                    {idx + 1}
                  </button>
                ))}


                {page < 11 ? (
                  <button className="btn btn-info" type="button" onClick={() => nextPage()}>
                    {"Next Page >"}
                  </button>
                ) : null}

              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-2 col-xl-2">
              <p>Page Latest: 11</p>
            </div>
          </div>
        </div>

        <div className="card col-12  m-3">
          <p className=" text-end"> total number of bike theft cases: {countBikes}</p>
        </div>

      </div>
    )
}

export default FormBikes